var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7674_14857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0469 15.2656V22.0527C23.0469 22.5912 22.6088 23.0293 22.0703 23.0293H2.92969C2.39121 23.0293 1.95312 22.5912 1.95312 22.0527V15.2656H0V22.0527C0 23.6682 1.31426 24.9824 2.92969 24.9824H22.0703C23.6857 24.9824 25 23.6682 25 22.0527V15.2656H23.0469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.015625L6.43146 6.08418L7.81251 7.46523L11.5234 3.7543V18.9748H13.4766V3.7543L17.1875 7.46523L18.5686 6.08418L12.5 0.015625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7674_14857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.560211135433ffd748a78123682bd006.svg";
export { ForwardRef as ReactComponent };